import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Download, ArrowLeft, ImageDown, Smartphone } from "lucide-react";
import { API } from "@/lib/config";

export default function FleetProposalPage() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    fetch(`${API}/fleet/proposal/pages`)
      .then((r) => r.json())
      .then((d) => setCount(d.count || 0))
      .catch(() => setCount(4));
  }, []);

  const pages = Array.from({ length: count || 4 }, (_, i) => i + 1);

  return (
    <div className="min-h-screen bg-black py-10 px-4">
      <div className="max-w-3xl mx-auto">
        <Link to="/fleet" className="inline-flex items-center gap-2 text-zinc-400 hover:text-white text-sm mb-8 transition-colors">
          <ArrowLeft size={14} /> Back to Fleet
        </Link>

        <div className="text-xs uppercase tracking-[0.25em] text-zinc-500 mb-3">Fleet proposal · Save & print</div>
        <h1 className="font-heading text-3xl md:text-4xl tracking-tight text-chrome mb-4">Your proposal pages</h1>

        {/* How-to */}
        <div className="rounded-2xl border border-zinc-800 bg-zinc-950 p-5 mb-8">
          <div className="flex items-start gap-3 mb-3">
            <Smartphone size={18} className="text-zinc-300 mt-0.5 shrink-0" />
            <div>
              <div className="text-white text-sm font-medium mb-1">On your phone</div>
              <p className="text-zinc-400 text-sm leading-relaxed">Press &amp; hold any page below → tap <span className="text-white">"Save to Photos"</span>. Do that for each page, then print from your camera roll.</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <ImageDown size={18} className="text-zinc-300 mt-0.5 shrink-0" />
            <div>
              <div className="text-white text-sm font-medium mb-1">On a computer</div>
              <p className="text-zinc-400 text-sm leading-relaxed">Click the <span className="text-white">"Save page"</span> button under each image to download it.</p>
            </div>
          </div>
        </div>

        {/* Pages */}
        <div className="space-y-8">
          {pages.map((n) => (
            <div key={n} data-testid={`proposal-page-${n}`} className="rounded-xl overflow-hidden border border-zinc-800 bg-zinc-950">
              <img
                src={`${API}/fleet/proposal/page/${n}.png`}
                alt={`Fleet proposal page ${n}`}
                className="w-full block"
                loading="lazy"
              />
              <div className="flex items-center justify-between px-4 py-3 border-t border-zinc-800">
                <span className="text-xs text-zinc-500">Page {n} of {count || 4}</span>
                <a
                  href={`${API}/fleet/proposal/page/${n}.png`}
                  download={`OTGG-Fleet-Proposal-Page-${n}.png`}
                  data-testid={`save-page-${n}`}
                  className="inline-flex items-center gap-2 h-9 px-4 rounded-full bg-white text-black text-sm font-medium hover:bg-zinc-200 transition-colors"
                >
                  <Download size={14} /> Save page
                </a>
              </div>
            </div>
          ))}
        </div>

        <p className="text-center text-zinc-600 text-xs mt-10">
          Prefer one file? <a href={`${API}/fleet/proposal.pdf`} target="_blank" rel="noopener noreferrer" className="text-zinc-400 underline hover:text-white">Download the full PDF</a>.
        </p>
      </div>
    </div>
  );
}
